






















import { Component, Emit, Mixins, Prop } from 'vue-property-decorator'

import FlowsTemplatesMixin from '../../FlowsTemplates/FlowsTemplatesMixin'
import SelectTemplateStep from '../../FlowsTemplates/steps/SelectTemplateStep.vue'
import SelectedTemplateStep from '../../FlowsTemplates/steps/SelectedTemplateStep.vue'
import { ActiveBotLicenseSteps, WizardComplete } from '../../FlowsTemplates/types'
import { FlowsListConfig } from '../types'

@Component({
  components: {
    SelectTemplateStep,
    SelectedTemplateStep
  },
  data() {
    return {
      ActiveBotLicenseSteps
    }
  }
})
export default class ImportFlowTemplate extends Mixins<FlowsTemplatesMixin>(FlowsTemplatesMixin) {
  @Prop() flowTemplateConfig!:FlowsListConfig['importFlowTemplate']

  @Emit()
  closeModal() {
    return null
  }

  isTemplateCreating = false

  onComplete(_: WizardComplete) {
    this.isTemplateCreating = true

    this.flowTemplateConfig.onComplete({ template: this.selectedTemplate?.config })
      .then(() => {
        this.closeModal()
      })
    .finally(() => {
      this.isTemplateCreating = false
    })
  }

  mounted() {
    this.currentStep = ActiveBotLicenseSteps.SelectTemplate
  }
}
